import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_SYNC_ADMIN = '[BenutzerverwaltungModul] PostBenutzerSyncAdmin laden';
export const POST_BENUTZER_SYNC_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerSyncAdmin ausführen';
export const POST_BENUTZER_SYNC_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerSyncAdmin laden erfolgreich';
export const POST_BENUTZER_SYNC_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerSyncAdmin Ladefehler';
export const POST_BENUTZER_SYNC_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerSyncAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerSyncAdminAction implements Action {
    readonly type = POST_BENUTZER_SYNC_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class PostBenutzerSyncAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_SYNC_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class PostBenutzerSyncAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_SYNC_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public optPayload: any = null) {}
    }
export class PostBenutzerSyncAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_SYNC_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class PostBenutzerSyncAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_SYNC_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerSyncAdminActions =
    PostBenutzerSyncAdminAction
    | PostBenutzerSyncAdminAusfuehrenAction
    | PostBenutzerSyncAdminErfolgreichAction
    | PostBenutzerSyncAdminFehlerAction
    | PostBenutzerSyncAdminNichtAusgefuehrtAction
    ;
